<template>
  <b-container class="w-75 border" fluid>
    <InputFuneral v-show="!funeral"></InputFuneral>
    <b-row class="justify-content-md-center text-center">
      <b-col lg="4" class="pb-2"><b-button size="lg">다음</b-button></b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'BugoInput',
  components: { // 여기서 동적으로 로딩한다
    'InputFuneral': () => import('@/components/write-bugojang/InputFuneral'),
  },
  data () {
    return {
      funeral: null,
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
